
define('ldsh!modules/start/products/landings/activity/template', ['lodash'], function(_) {return function(obj) {
obj || (obj = {});
var __t, __p = '', __e = _.escape, __j = Array.prototype.join;
function print() { __p += __j.call(arguments, '') }
with (obj) {

 if (isAdm) { ;
__p += '\n<div class="col-xs-8 col-sm-10 col-md-4 col-lg-4">\n';
 } else { ;
__p += '\n<div class="col-xs-8 col-sm-10 col-md-10 col-lg-10">\n';
 } ;
__p += '\n    <div class="row">\n        <div class="col-md-12 col-lg-12">\n            <h3 class="i18n" style="margin-top: 5px;" data-i18n="PUBLIC.PRODUCTS.LANDINGS.PRODUCT_NAME"></h3>\n        </div>\n    </div>\n\n    <div class="row">\n        <div class="col-md-12 col-lg-12" style="min-height: 27px;">\n            <p><b class="i18n" data-i18n="PUBLIC.PRODUCTS.LANDINGS.LBL_PRINTS"></b>\n                &nbsp;<span class="product-number">' +
__e(formatNumber(prints)) +
'</span></p>\n        </div>\n    </div>\n\n    <div class="row product-activity-table">\n        <div class="col-xs-12 product-activity-row">\n            <table>\n                <tr>\n                    <td class="product-border-right">\n                         <span class="product-number">' +
__e(formatNumber(visits)) +
'</span><span class="i18n" style="font-size: 11px;" data-i18n="PUBLIC.PRODUCTS.LOWBAR.VISITS"></span>\n                    </td>\n                    <td class="product-border-right">\n                        <span class="product-number">' +
__e(formatNumber(conversion)) +
'</span><span class="i18n" style="font-size: 11px;" data-i18n="PUBLIC.PRODUCTS.LOWBAR.CONVERSIONS"></span>\n                    </td>\n                    <td>\n                        <span class="product-number">' +
__e(formatNumber(conversion_percent)) +
'</span><span class="i18n" style="font-size: 11px;" data-i18n="PUBLIC.PRODUCTS.LOWBAR.CONV_CTR"></span>\n                    </td>\n                </tr>\n            </table>\n        </div>\n\n    </div>\n\n</div>\n';

}
return __p
};});

